

// eslint-disable-next-line
import { handleResponseJson,handleResponseVoid, handleError } from "../../apiUtils";


    /**
    * Returns mentor localizations for specified language code.
    **/
    export function localizations(language: string, authToken:string): Promise<{ [key: string]: string; }>{
        var url = `api/mentor/localizations/${encodeURIComponent(language)}`;
        return (
                fetch(url, 
                {
                    method: "get",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }



